import logo from './miotly-removebg-preview.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h2>
          Trwaja prace porządkowe.<br></br>
          Strona w budowie.
        </h2>
      </header>
    </div>
  );
}

export default App;
